import React, { ReactNode } from 'react';
import { Div } from '@pezeshk-book/ui-kit';
import classNames from '@utils/helpers/class-names';

const Container = ({ children, className, ref }: {children: ReactNode, className?: string, ref?: any}) => {
  return (
    <Div className={classNames('w-full max-w-[1432px] md:py-12 py-3 px-3 md:px-4 self-center items-center justify-center')} ref={ref}>
      <Div className={classNames('w-full max-w-[1400px] self-center', className)}>
        {children}
      </Div>
    </Div>
  );
};

export default Container;
